module.exports = " <quote :message=message></quote> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ferment/agitator-definition.vue
// module id = 447
// module chunks = 2